module.exports = __webpack_public_path__ + "static/media/check-symbol-4794.19f3b5f3.svg";